/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useCallback, useMemo } from "react";
import { getSessionStorage, hasNullSessionValue } from "../../utils/util";
import {  SESSION_STORAGE_KEY } from "../../vars";
import useOtp from "../../customHook/useOtp";
import appleIcon from "../../assets/images/apple-icon.svg";
import googleIcon from "../../assets/images/g-plus-icon.svg.svg";

// eslint-disable-next-line no-unused-vars
function EmailCompo() {
    const inviteCode = useMemo(() => (hasNullSessionValue(SESSION_STORAGE_KEY.INVITE_CODE) ? getSessionStorage(SESSION_STORAGE_KEY.INVITE_CODE) : null), []);
    const { sendOtp } = useOtp();
   

    const handleLoginWithGoogle = useCallback(() => {
        sendOtp({  promptType: "select_account", connection: "google-oauth2-prod", inviteCode });
    }, [sendOtp,inviteCode]);
    const handleLoginWithApple = useCallback(() => {
        sendOtp({ promptType: "select_account", connection: "apple", inviteCode });
    }, [sendOtp,inviteCode]);

	return (
		<div className="flex flex-col items-center mt-6 px-4 max-w-[28rem] mx-auto w-full relative">
				<div className="flex items-center justify-center w-full mb-6">
					<hr className="flex-grow border-t border-gray-300" />
					<span className="mx-2 text-gray-500 text-sm">OR</span>
					<hr className="flex-grow border-t border-gray-300" />
				</div>
				<div className="w-full">
					<button
						type="button"
						onClick={handleLoginWithApple}
						className="flex w-full items-center justify-center mb-4 cursor-pointer rounded-md border-none bg-[#F9FAFC] py-3 px-4"
						aria-label="Continue with Google"
					>
						<img src={appleIcon} alt="Google Icon" className="inline-block w-5 h-5 mr-2" />
						<span className="flex-1">Continue with Apple </span>
					</button>
					<button
						type="button"
						onClick={handleLoginWithGoogle}
						className="flex w-full items-center justify-center mb-4 cursor-pointer rounded-md border-none bg-[#F9FAFC] py-3 px-4"
						aria-label="Continue with Google"
					>
						<img src={googleIcon} alt="Google Icon" className="inline-block w-5 h-5 mr-2" />

                            <span className="flex-1">Continue with Google</span>
                        </button>
                    </div>
                </div>
    );
}

export default EmailCompo;
